import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
  Root,
} from '@radix-ui/react-accordion';

import {InnerAccordionProps} from './InnerAccordion.types';

import * as css from './InnerAccordion.css';

/**
 * The Accordion component is built on top of the Accordion component provided
 * by Radix-UI. It renders an `AccordionItem` component, which must be nested
 * inside of an `AccordionRoot` component. It accepts all of the props that
 * a Radix-UI `AccordionItem` accepts. For more information on functionality,
 * see:
 *
 * - https://www.radix-ui.com/docs/primitives/components/accordion
 *
 * The only styles provided by the "Util" version of the accordion are an
 * animated open/closing transition.
 */
export const InnerAccordion = ({
  children,
  trigger,
  triggerClassName,
  ...otherProps
}: InnerAccordionProps) => (
  <AccordionItem {...otherProps}>
    <AccordionHeader>
      <AccordionTrigger className={triggerClassName}>{trigger}</AccordionTrigger>
    </AccordionHeader>

    <AccordionContent className={css.content}>{children}</AccordionContent>
  </AccordionItem>
);

export const AccordionRoot = Root;
